export default __webpack_public_path__ + "assets/images/1775d2129ef1010ca220c1734fca04f3.png";